export default {
      id: "unavailable-usage",
      viewBox: "0 0 11 13",
      url: __webpack_public_path__ + "sprite-46b249.svg#unavailable-usage",
      toString: function () {
        return this.url;
      }
    }